const Divider = {
  defaultProps: {
    color: 'var(--mantine-color-border-surface)',
  },
}

export default Divider
